export default {
  frontEndStatus: "Front machine running status",
  appName: "front-end machine name",
  versionNo: "Version",
  status: "Status",
  normal: 'normal',
  dataModelNum: "Number of digital modules created by each enterprise",
  userDataCount: "Total enterprise user data",
  legalDataCount: "Total number of enterprise user certificates",
  dataShopDataCount: "Data store data volume",
  dataModelShopDataCount: "Data Model store data volume",
  monitor: "CPU/Hard Disk Monitoring",
  legalCountRank: "Number and Ranking of depositories",
  dataShareRank: "Number and ranking of data shares",
  hardDisk: "Hard disk",
  company: " Company",
  legal: " Number of certificates",
  rank: "rank",
  callStatistics: {
    all: 'ALl',
    lastWeek: 'Last week',
    allAPI: 'ALL API',
    callNumber: 'API Number of calls ',
    flowStatistics: 'API Indicates traffic statistics (kb)',
    startPlaceholder: 'Start date time ',
    endPlaceholder: 'End date time ',
    successTimes: 'Number of successful times ',
    errorTimes: 'Number of failures ',
    totalCalls: 'total number of calls ',
    totalFlow: 'total flow ',
    network: 'Request failed, ',
    refresh: 'Click refresh ',
    empty: 'No data available ',
    successCount: 'Number of successes ',
    failCount: 'Number of failures',
    apiSurvival: 'API Survival',
    apiName: 'API name',
    responseContentLength: 'Response duration',
    status: 'Response code',
    statusName: 'Call result',
    success: 'Success',
    fail: 'Fail'
  }
}


// WEBPACK FOOTER //
// ./src/views/statistics/statistics.en.js